import { useMemo, useState, useCallback } from 'react';
import styles from './OutcastDomain.module.css';

export default function OutcastDomain({ sendEvent = async () => {} }){
  const [openIds, setOpenIds] = useState(() => new Set()); // секції гуртів за замовчуванням згорнуті

  const bands = useMemo(() => ([
    {
      id: 'recone',
      name: 'Recone',
      youtube: 'https://youtu.be/hBg5Uu1PilI',
      text: [
        'Recone — мелодійний металкор-гурт з Києва, де щільний важкий звук поєднується з емоційною точністю. Вони будують напругу так, щоб вона не просто тиснула — а вела крізь переживання.',
        'Outcast Domain — це територія для тих, хто не вписується. Не втеча, а простір, де темні думки можна прожити чесно, без масок і без зайвих слів. Тут важка музика працює як мова, якою нарешті дозволено говорити.',
        'У такий вечір Recone звучить максимально “в лоб”: як кульмінація, як удар, як катарсис. Це не фон — це головна точка події, де напруга доходить до піку й перетворюється на енергію.',
      ],
      phase: 'Хедлайнер',
    },
    {
      id: 'angelform',
      name: 'Angel Form',
      youtube: 'https://youtu.be/XxP8hNr2oa8',
      text: [
        'Angel Form — metal гурт із Білої Церкви, що грає важкий modern metalcore. Їхня музика — про біль, втрати й депресію, але також про силу триматися і рухатися далі, коли всередині шторм.',
        'У контексті Outcast Domain Angel Form — спеціальні гості: той самий момент, коли відвертість стає ще глибшою. Вони задають правильний тон вечора — напружений, щирий і максимально живий.',
      ],
      phase: 'Спец-Гості',
    },
  ]), []);

  const coverUrl = '/covers/Outcast_Domain_Cover.png';
  const tgUrl = 'https://t.me/qpcoreadmin';
  const waUrl = 'https://wa.me/+48784196320';

  // ГОЛОВНА сторінка веб-додатку
  const homeUrl = '/';

  const toggle = (id) => {
    setOpenIds(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const fire = useCallback(async (name) => {
    try { await sendEvent(name); } catch {}
  }, [sendEvent]);

  const onTelegramClick = () => fire('Telegram Tunnel');
  const onWhatsAppClick = () => fire('WhatsApp Tunnel');
  const onHomeClick = () => fire('Go Home Page');

  return (
    <div className={styles.page}>
      <header className={styles.hero}>
        <div className={styles.coverCol}>
          <div className={styles.coverFrame} aria-label="Обкладинка івенту">
            <img
              className={styles.coverImg}
              src={coverUrl}
              alt="Outcast Domain cover"
              loading="eager"
              onError={(e) => {
                e.currentTarget.style.display = 'none';
                const ph = e.currentTarget.parentElement?.querySelector(`.${styles.coverPlaceholder}`);
                if (ph) ph.style.display = 'grid';
              }}
            />
            <div className={styles.coverPlaceholder} style={{ display: 'none' }}>
              <div className={styles.placeholderText}>Немає зображення</div>
            </div>

            <div className={styles.coverGlow} aria-hidden="true" />
            <div className={styles.coverScrim} aria-hidden="true" />
          </div>

          <div className={styles.miniBadges}>
            <span className={styles.badge}>Cult Project</span>
            <span className={styles.badgeStrong}>Outcast Domain</span>
            <span className={styles.badge}>15/03 • Біла Церква • BunkerMuz</span>
          </div>
        </div>

        <div className={styles.infoCol}>
          <h1 className={styles.title}>Outcast Domain</h1>
          <p className={styles.subtitle}>
            Територія для тих, хто давно зрозумів: вписуватися — це не про мене.
          </p>

          <div className={styles.textBlock}>
            <p>
              Headliner - Recone (Kyiv). Вони грають так, ніби знають, що в тебе всередині, і не бояться це витягнути назовні.

              Special guest - Angel Form (Bila Tserkva). Кожен їхній риф — як питання, на яке ти давно знаєш відповідь, але боїшся його озвучити.
            </p>
            <p>
              Разом вони створюють вечір, де не треба пояснювати, чому ти такий, який є … і якщо ти відчуваєш, що давно шукаєш саме таке місце — приходь, буде дуже живо.
            </p>
          </div>

          <div className={styles.ctaCard} id="tickets">
            <div className={styles.ctaTitle}>Квитки</div>
            <div className={styles.ctaText}>
              Хочете потрапити на подію? Виберіть зручний месенджер та напишіть нам — ми допоможемо придбати квиток і відповімо на запитання.
              Ми не збираємо і не передаємо Ваші дані маркетинговим сервісам, як це можуть робити інші сайти — ми навіть не використовуємо кукі 🫠
            </div>

            <div className={styles.ctaButtons}>
              <a
                className={`${styles.btn} ${styles.btnPrimary}`}
                href={tgUrl}
                target="_blank"
                rel="noreferrer"
                onClick={onTelegramClick}
              >
                <IconTelegram className={styles.btnIcon} />
                <span className={styles.btnLabel}>Telegram</span>
              </a>

              <a
                className={`${styles.btn} ${styles.btnGhost}`}
                href={waUrl}
                target="_blank"
                rel="noreferrer"
                onClick={onWhatsAppClick}
              >
                <IconWhatsApp className={styles.btnIcon} />
                <span className={styles.btnLabel}>WhatsApp</span>
              </a>
            </div>
          </div>

          {/* НОВА ПЛАШКА: Home */}
          <div className={styles.ctaCard}>
            <div className={styles.ctaTitle}>ВЖЕ ЗНАЄШ ЯК КОРИСТУВАТИСЯ ПЛАТФОРМОЮ?</div>
            <div className={styles.ctaText}>
              Відкрий цей Веб-Додаток у НОРМАЛЬНОМУ БРАУЗЕРІ, бо якщо ти перейшов з РЕКЛАМИ щоб обрати подію або перейти у твій простір,
              то ти не зможеш зареєструватись! Цю Платформу розроблено в Україні, приємного користування!
            </div>

            <div className={styles.ctaButtons}>
              <a
                className={`${styles.btn} ${styles.btnHome} ${styles.btnSpan}`}
                href={homeUrl}
                onClick={onHomeClick}
              >
                <IconHome className={styles.btnIcon} />
                <span className={styles.btnLabel}>До Квитків</span>
              </a>
            </div>
          </div>
        </div>
      </header>

      <main className={styles.main} id="bands">
        <div className={styles.sectionHead}>
          <h2 className={styles.sectionTitle}>Хто виступає</h2>
          <div className={styles.sectionHint}>Секції згорнуті — відкривай по черзі.</div>
        </div>

        <div className={styles.bandList}>
          {bands.map(band => {
            const isOpen = openIds.has(band.id);
            const ytId = getYoutubeId(band.youtube);

            return (
              <section key={band.id} className={styles.bandCard}>
                <button
                  type="button"
                  className={styles.bandHeader}
                  onClick={() => toggle(band.id)}
                  aria-expanded={isOpen ? 'true' : 'false'}
                >
                  <div className={styles.bandHeaderLeft}>
                    <div className={styles.bandNameRow}>
                      <div className={styles.bandName}>{band.name}</div>
                      <div className={styles.phase}>{band.phase}</div>
                    </div>
                    <div className={styles.bandMeta}>
                      YouTube • прев’ю гурту
                    </div>
                  </div>

                  <span className={`${styles.pmWrap} ${isOpen ? styles.pmOpen : ''}`} aria-hidden="true">
                    <span className={styles.pm} />
                  </span>
                </button>

                <div className={`${styles.bandBody} ${isOpen ? styles.bandBodyOpen : ''}`}>
                  <div className={styles.bandInner}>
                    <div className={styles.videoFrame}>
                      <iframe
                        className={styles.iframe}
                        src={`https://www.youtube-nocookie.com/embed/${ytId}`}
                        title={`${band.name} video`}
                        loading="lazy"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      />
                    </div>

                    <div className={styles.bandText}>
                      {band.text.map((p, idx) => (
                        <p key={idx}>{p}</p>
                      ))}

                      <a className={styles.youtubeLink} href={band.youtube} target="_blank" rel="noreferrer">
                        Відкрити на YouTube
                        <span className={styles.linkArrow} aria-hidden="true">↗</span>
                      </a>
                    </div>
                  </div>
                </div>
              </section>
            );
          })}
        </div>

        {/* Нижній блок як "Квитки" */}
        <footer className={styles.footerCta}>
          <div className={styles.ctaTitle}>Вагаєшся?</div>
          <div className={styles.ctaText}>
            Обери месенджер — і отримай інформацію, яка допоможе з вибором, без зайвих форм і даних.
          </div>

          <div className={styles.ctaButtons}>
            <a
              className={`${styles.btn} ${styles.btnPrimary}`}
              href={tgUrl}
              target="_blank"
              rel="noreferrer"
              onClick={onTelegramClick}
            >
              <IconTelegram className={styles.btnIcon} />
              <span className={styles.btnLabel}>Telegram</span>
            </a>

            <a
              className={`${styles.btn} ${styles.btnGhost}`}
              href={waUrl}
              target="_blank"
              rel="noreferrer"
              onClick={onWhatsAppClick}
            >
              <IconWhatsApp className={styles.btnIcon} />
              <span className={styles.btnLabel}>WhatsApp</span>
            </a>
          </div>
        </footer>
      </main>
    </div>
  );
}

function getYoutubeId(url){
  try{
    const u = new URL(url);
    if (u.hostname.includes('youtu.be')) return u.pathname.replace('/', '');
    if (u.searchParams.get('v')) return u.searchParams.get('v');
    const parts = u.pathname.split('/').filter(Boolean);
    const idx = parts.indexOf('embed');
    if (idx >= 0 && parts[idx + 1]) return parts[idx + 1];
  }catch(e){}
  const m = String(url).match(/(?:youtu\.be\/|v=|\/embed\/)([A-Za-z0-9_-]{6,})/);
  return m?.[1] || '';
}

/* SVG icons (inline) */

function IconTelegram({ className = '' }){
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M9.2 14.6 8.9 19c.5 0 .7-.2 1-.5l2.4-2.3 5 3.7c.9.5 1.6.2 1.8-.8l3.3-15.5c.3-1.2-.5-1.7-1.4-1.3L2.3 10.2c-1.1.4-1.1 1.1-.2 1.4l4.6 1.4L17.8 6c.5-.3 1-.1.6.2L9.2 14.6Z"/>
    </svg>
  );
}

function IconWhatsApp({ className = '' }){
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 2a9.7 9.7 0 0 0-8.4 14.6L2.6 22l5.6-1.5A9.7 9.7 0 1 0 12 2Zm0 17.7c-1.5 0-3-.4-4.3-1.2l-.3-.2-3.3.9.9-3.2-.2-.3A7.7 7.7 0 1 1 12 19.7Z"/>
      <path d="M16.6 13.7c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.2l-.8 1c-.2.3-.4.3-.7.1-1.7-.8-2.8-2.1-3.2-2.8-.1-.3 0-.5.1-.6l.6-.7c.2-.2.2-.4.3-.6 0-.2 0-.4-.1-.6l-.9-2.1c-.2-.5-.5-.4-.7-.4h-.6c-.2 0-.6.1-.9.4-.3.3-1.2 1.2-1.2 2.9 0 1.7 1.2 3.4 1.4 3.6.2.2 2.4 3.6 5.8 5 .8.3 1.5.5 2 .6.8.3 1.6.2 2.2.1.7-.1 1.7-.7 1.9-1.4.2-.7.2-1.3.1-1.4 0-.1-.2-.2-.5-.3Z"/>
    </svg>
  );
}

function IconHome({ className = '' }){
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 3.2 2.8 11a1 1 0 0 0 1.3 1.5l1-.9V20a1.8 1.8 0 0 0 1.8 1.8h3.6a1 1 0 0 0 1-1v-5.4h2.9v5.4a1 1 0 0 0 1 1h3.6A1.8 1.8 0 0 0 20.9 20v-8.4l1 .9a1 1 0 1 0 1.3-1.5L12 3.2Zm6.9 16.8h-2.6v-5.6a1 1 0 0 0-1-1H9.7a1 1 0 0 0-1 1V20H6.1c-.4 0-.8-.4-.8-.8v-9l6.7-5.7 6.7 5.7v9c0 .4-.4.8-.8.8Z"/>
    </svg>
  );
}
